import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "./../../../../shared/Modal/Modal";
import { setStepParticipant, onCancelRelationshipParticipant } from "../../../actions/account-link";
import { bindActionCreators } from "redux";
import AccountLinkCard from "./AccountLinkCard";
import { setDataToStoreParticipant } from "./../../../actions/account-link";
import Callout from "./../../../../shared/Callout/Callout";
import { PARTICIPANT_DECLARATION } from "../../../shared/terms";

class AccountLinkHome extends Component {
	constructor() {
		super();
		this.state = {
			term: false,
			showReprove: false,
			showUnlink: false,
			showUnlinkIndication: false,
			showCalloutActive: false,
			showCalloutManagerReprove: false,
			showCalloutParticipantCancel: false,
			showCantNext: false,
			showCantApproveThisManager: false,
			showCantUnlink: false
		};

		this.nextStep = this.nextStep.bind(this);
		this.toggleUnlink = this.toggleUnlink.bind(this);
		this.toggleReprove = this.toggleReprove.bind(this);
		this.toggleCantUnlink = this.toggleCantUnlink.bind(this);
	}

	nextStep(data) {
		const { data: relationshipsData, dataOffers } = this.props;

		if (
			relationshipsData.some(
				rd =>
					rd._id != data._id &&
					rd.status.status != "I" &&
					rd.status.subStatus != "inviteSendParticipant"
			)
		) {
			this.setState({ showCantApproveThisManager: true });
		} else if (
			dataOffers &&
			dataOffers.offers &&
			dataOffers.offers.length &&
			dataOffers.offers.some(offer => offer.status != 0 && offer.status != 4)
		) {
			this.setState({ showCantNext: true });
		} else {
			this.props.setDataToStoreParticipant({
				relationId: data._id,
				idManager: data.idManager,
				idParticipant: data.idParticipant,
				manager: {
					name: data.manager.name,
					city: data.manager.city,
					ssn: data.manager.ssn
				}
			});
			this.props.incStep(this.state);
		}
	}

	componentDidMount() {
		this.checkCalloutToShowParticipant(this.props);
	}

	componentWillReceiveProps(nextProps) {
		this.checkCalloutToShowParticipant(nextProps);
	}

	checkCalloutToShowParticipant(props) {
		const { data } = props;

		if (data && data.length) {
			let lastIdCalloutActive = localStorage.getItem("lastIdCalloutActive");
			let lastIdCalloutParticipantCancel = localStorage.getItem("lastIdCalloutParticipantCancel");
			let lastIdCalloutManagerReprove = localStorage.getItem("lastIdCalloutManagerReprove");
			let params = undefined;
			for (let i = 0; i < data.length; i++) {
				let relationship = data[i];
				if (relationship._id == lastIdCalloutManagerReprove) {
					break;
				}
				if (
					relationship.evaluated == null &&
					(relationship.status.subStatus == "requestDeclinedManager" ||
						relationship.status.subStatus == "relationshipManagerCanceled")
				) {
					localStorage.setItem("lastIdCalloutManagerReprove", relationship._id);
					params = {
						showCalloutManagerReprove: true,
						showCalloutActive: false,
						showCalloutParticipantCancel: false
					};
					break;
				}
			}

			for (let i = 0; i < data.length; i++) {
				let relationship = data[i];
				if (relationship._id == lastIdCalloutParticipantCancel) {
					break;
				}
				if (
					relationship.evaluated != null &&
					(relationship.status.subStatus == "relationshipParticipantCanceled" ||
						relationship.status.subStatus == "relationshipManagerCanceled")
				) {
					localStorage.setItem("lastIdCalloutParticipantCancel", relationship._id);
					params = {
						showCalloutParticipantCancel: true,
						showCalloutActive: false,
						showCalloutManagerReprove: false
					};
					break;
				}
			}
			for (let i = 0; i < data.length; i++) {
				let relationship = data[i];
				if (relationship._id == lastIdCalloutActive) {
					break;
				}
				if (relationship.status.subStatus == "activeRelationship") {
					localStorage.setItem("lastIdCalloutActive", relationship._id);
					params = {
						showCalloutActive: true,
						showCalloutManagerReprove: false,
						showCalloutParticipantCancel: false
					};
					break;
				}
			}
			if (params) {
				this.setState(params);
			}
		}
	}

	toggleUnlink(dataToUnlink) {
		const { showUnlink, showUnlinkIndication } = this.state;
		if (!!dataToUnlink.evaluated) {
			this.setState({ showUnlink: !showUnlink, dataToUnlink });
		} else {
			this.setState({ showUnlinkIndication: !showUnlinkIndication, dataToUnlink });
		}
	}

	toggleReprove(dataToReprove) {
		const { showReprove } = this.state;
		this.setState({ showReprove: !showReprove, dataToReprove });
	}

	toggleCantUnlink() {
		const { showCantUnlink } = this.state;
		this.setState({ showCantUnlink: !showCantUnlink });
	}

	isValid() {
		return false;
	}

	onCancelRelationshipParticipantUnlink = () => {
		const { dataToUnlink } = this.state;
		this.props.onCancelRelationshipParticipant(
			{
				relationId: dataToUnlink._id,
				idManager: dataToUnlink.idManager
			},
			() => this.toggleUnlink(dataToUnlink)
		);
	};

	onCancelRelationshipParticipantReprove = () => {
		const { dataToReprove } = this.state;
		this.props.onCancelRelationshipParticipant(
			{
				relationId: dataToReprove._id,
				idManager: dataToReprove.idManager
			},
			() => this.toggleReprove()
		);
	};

	render() {
		const {
			showReprove,
			showUnlink,
			showUnlinkIndication,
			showCalloutActive,
			showCalloutManagerReprove,
			showCalloutParticipantCancel,
			showCantNext,
			showCantApproveThisManager,
			showCantUnlink
		} = this.state;
		const { data, loadingOffers, dataOffers } = this.props;

		return (
			<React.Fragment>
				<div
					className={
						window.screen.availWidth <= 468
							? "account-link-home no-padding no-margin"
							: "account-link-home--buttons-top"
					}
				>
					<div className="account-link-home--buttons-top">
						<a
							className="account-link-home--buttons-top--download"
							href={PARTICIPANT_DECLARATION}
							target="_blank"
						>
							<i className="icon-export" />
							Baixar Declaração de Vínculo
						</a>
					</div>
					<Callout
						show={showCalloutActive}
						success
						icon="check"
						text={
							<span>
								<strong>Seu vínculo de conta está ativo!</strong>
							</span>
						}
					/>
					<Callout
						show={showCalloutManagerReprove}
						danger
						icon="close"
						text={
							<span>
								<strong>Sua solicitação foi reprovada pelo gestor.</strong>
							</span>
						}
					/>
					<Callout
						show={showCalloutParticipantCancel}
						danger
						icon="close"
						text={
							<span>
								<strong>Sua conta foi desvinculada.</strong>
							</span>
						}
					/>

					{data &&
						!loadingOffers &&
						data.map(data => {
							return (
								<AccountLinkCard
									key={data._id}
									data={data}
									nextStep={this.nextStep}
									toggleUnlink={this.toggleUnlink}
									toggleReprove={this.toggleReprove}
									toggleCantUnlink={this.toggleCantUnlink}
									dataOffers={dataOffers}
								/>
							);
						})}
				</div>

				<Modal
					title="Reprovar solicitação"
					description="Para rejeitar esta solicitação de vínculo clique em Reprovar solicitação."
					cancel="Voltar"
					confirm="Reprovar solicitação"
					show={showReprove}
					onCancel={() => this.setState({ showReprove: false })}
					onConfirm={() => this.onCancelRelationshipParticipantReprove()}
					fixed={true}
				/>
				<Modal
					title="Desvincular conta"
					description="Você tem certeza que deseja desfazer o vínculo entre essas contas?"
					cancel="Desvincular"
					confirm="Manter vínculo"
					show={showUnlink}
					onConfirm={() => this.setState({ showUnlink: false })}
					onCancel={() => this.onCancelRelationshipParticipantUnlink()}
					fixed={true}
					withoutClose={true}
				/>
				<Modal
					title="Excluir indicação"
					description="Você tem certeza que deseja excluir a indicação deste participante?"
					cancel="Excluir"
					confirm="Manter indicação"
					show={showUnlinkIndication}
					onConfirm={() => this.setState({ showUnlinkIndication: false })}
					onCancel={() => this.onCancelRelationshipParticipantUnlink()}
					fixed={true}
					withoutClose={true}
				/>
				<Modal
					title="Atenção!"
					description="Não é possível desvincular sua conta nesse momento, pois você tem uma oferta ativa. Para continuar, exclua sua oferta ou aguarde até que a venda seja finalizada."
					confirm="Ok, entendi"
					show={showCantUnlink}
					onConfirm={() => this.toggleCantUnlink()}
					fixed={true}
				/>
				<Modal
					title="Atenção"
					description="Você tem ofertas em andamento, por isso, não é possível seguir com o processo de vínculo de conta."
					confirm="Ok, entendi"
					show={showCantNext}
					onConfirm={() => this.setState({ showCantNext: false })}
					fixed={true}
				/>
				<Modal
					title="Atenção"
					description="Não é possível aprovar a indicação desse gestor, pois você tem outro processo de vínculo em andamento."
					confirm="Ok, entendi"
					show={showCantApproveThisManager}
					onConfirm={() => this.setState({ showCantApproveThisManager: false })}
					fixed={true}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	data: state.accountLink.dataRelationshipParticipant
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStepParticipant,
			onCancelRelationshipParticipant,
			setDataToStoreParticipant
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AccountLinkHome);
